module.exports = __webpack_public_path__ + "img/icon_self.35765457.svg";